import React from 'react';
import {useSnapshot} from "valtio";
import {state, configuratorState} from '../../../../state.js';

const SwatchBtn = ({value}) => {
  const {materialsLocation, materialCategoryLocation} = useSnapshot(state);
  const {selectedMaterialGroup} = useSnapshot(configuratorState);
  const title = value.title;
  
  return (
    
    <div className="swatch">
      <img alt={title} title={title} src={materialsLocation + materialCategoryLocation + selectedMaterialGroup + "/" + value.textureSet.srcDiffuse} />
      {/* <div className="label">
        {title}
      </div> */}
    </div>
  
  )
};

export default SwatchBtn;
